import type { FeatureGroup } from '../../types';

export const CRM_INTEGRATIONS_FEATURE_GROUP: FeatureGroup = {
  guid: '1b25c787-2ee1-4c14-be14-f3165abffdf3',
  name: 'crm_integrations',
  description: 'Root group for all CRM integration features — calendar, tickets, email, development, etc.',
  product: 'app',
};
